import { Card, Typography, Row, Col, Divider, Button, Spin } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../slice";
import { actions as orderListingActions } from "../../OrderListing/slice";
import * as selectors from "../selectors";
import { useState } from "react";
import { dateTimeToString } from "../../../../../utils/formatter";
import { FaClipboardList } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const { Title, Text } = Typography;

const DisputeAnalysis = ({ selectedCommodities, dateRange }) => {
  const dispatch = useDispatch();
    const history = useHistory();

  const disputeAnalysis = useSelector(selectors.selectDisputeAnalysis);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      actions.getDisputeAnalysis({
        selectedCommodities,
        dateRange,
        onSuccess: () => {
          setIsLoading(false);
        },
        onFailure: () => {
          setIsLoading(false);
        },
      })
    );
  }, [dispatch, selectedCommodities, dateRange]);

    const handleViewAllClick = () => {
      dispatch(orderListingActions.setActiveNavOption("UNDER DISPUTE"));
      history.push("/labPortal");
    };

  return (
    <Card
      bordered
      style={{
        borderRadius: 8,
        minHeight: 755,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Header */}
        <Title level={4} style={{ marginBottom: 0 }}>
          Dispute Analysis
        </Title>

        {disputeAnalysis?.totalDisputeOrders ? (
          <Button 
            type="primary" 
            onClick={handleViewAllClick}
            style={{
              background: "linear-gradient(135deg, #ff6b6b, #F97316)",
              border: "none",
              borderRadius: "8px",
              padding: "4px 16px",
              height: "36px",
              fontWeight: 500,
            }}
          >
            View All Disputed Orders →
          </Button>
        ) : null}
      </div>
      {isLoading ? (
        <div
          style={{
            minHeight: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <Spin size="large" />
          <div style={{ marginTop: 12 }}>Loading...</div>
        </div>
      ) : disputeAnalysis?.totalDisputeOrders === 0 ? (
        <div
          style={{
            minHeight: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "48px",
              marginBottom: "16px",
              color: "#d9d9d9",
            }}
          >
            <FaClipboardList color="#1C8A7A" />
          </div>
          <Title level={4} style={{ color: "#8c8c8c", marginBottom: 8 }}>
            No Disputes
          </Title>
          <Text type="secondary" style={{ fontSize: "14px" }}>
            No disputed orders found in the selected period.
          </Text>
        </div>
      ) : (
        <>
          <div style={{ textAlign: "center", margin: "12px 0" }}>
            <Title level={2} style={{ color: "#F97316", marginBottom: 0 }}>
              {disputeAnalysis?.totalDisputeOrders || 0}
            </Title>
            <Text type="secondary">Active Disputes</Text>
          </div>
          <Title level={5} style={{ color: "#F97316", marginBottom: 8 }}>
            Latest{" "}
            {disputeAnalysis.totalDisputeOrders > 3
              ? 3
              : disputeAnalysis.totalDisputeOrders}{" "}
            Disputed Orders
          </Title>

          {/* --- Summary Section --- */}
          {/* <div style={{ marginBottom: 12 }}>
            <Row
              justify="space-between"
              align="middle"
              style={{
                background: "#f8fafc",
                borderRadius: 8,
                padding: "10px 14px",
                marginBottom: 8,
              }}
            >
              <Text style={{ fontWeight: 500 }}>Reports</Text>
              <Button
                type="text"
                shape="circle"
                style={{
                  border: "1px solid #e2e8f0",
                  color: "#45b7d1",
                  background: "transparent",
                  width: 26,
                  height: 26,
                  padding: 0,
                  fontWeight: 500,
                }}
              >
                {disputeAnalysis?.correctionStatistics?.report || 0}
              </Button>
            </Row> */}

          {/* Acceptance Form */}
          {/* <Row
              justify="space-between"
              align="middle"
              style={{
                background: "#f8fafc",
                borderRadius: 8,
                padding: "10px 14px",
                marginBottom: 8,
              }}
            >
              <Text style={{ fontWeight: 500 }}>Acceptance Form</Text>
              <Button
                type="text"
                shape="circle"
                style={{
                  border: "1px solid #e2e8f0",
                  color: "#ff6b6b",
                  background: "transparent",
                  width: 26,
                  height: 26,
                  padding: 0,
                  fontWeight: 500,
                }}
              >
                {disputeAnalysis?.correctionStatistics?.acceptanceForm || 0}
              </Button>
            </Row> */}

          {/* Labelling Form */}
          {/* <Row
              justify="space-between"
              align="middle"
              style={{
                background: "#f8fafc",
                borderRadius: 8,
                padding: "10px 14px",
              }}
            >
              <Text style={{ fontWeight: 500 }}>Labelling Form</Text>
              <Button
                type="text"
                shape="circle"
                style={{
                  border: "1px solid #e2e8f0",
                  color: "#4ecdc4",
                  background: "transparent",
                  width: 26,
                  height: 26,
                  padding: 0,
                  fontWeight: 500,
                }}
              >
                {disputeAnalysis?.correctionStatistics?.labellingForm || 0}
              </Button>
            </Row>
          </div> */}

          {/* Divider */}
          {/* <Divider plain style={{ fontWeight: 500, color: "#d46b08" }}>
            Recent Open Dispute Cases
          </Divider> */}
          {disputeAnalysis?.disputeOrders?.map((order) => (
            <Card
              key={order._id}
              size="small"
              style={{
                background: "#fff",
                border: "1px solid #fde1c4",
                borderRadius: 8,
                marginBottom: 12,
              }}
            >
              <Row justify="space-between" align="middle">
                <Col>
                  <Text strong>Order ID: {order.orderId}</Text>
                </Col>
                <Col>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {order?.disputeDetails?.requestCorrections?.map(
                      (request) => (
                        <Button
                          key={request._id}
                          type="text"
                          style={{
                            background: "#fde1c4",
                            color: "#F97316",
                            borderRadius: 16,
                            fontWeight: 500,
                            height: 24,
                            padding: "0 10px",
                          }}
                        >
                          {requestCorrectionsMap[request.type]}
                        </Button>
                      )
                    )}
                  </div>
                </Col>
              </Row>

              <Text type="secondary" style={{ display: "block", marginTop: 4 }}>
                {order.commodityName}
              </Text>

              <div
                style={{
                  background: "#fff5e6",
                  borderRadius: 4,
                  padding: "6px 10px",
                  marginTop: 8,
                }}
              >
                <Text>{order.disputeDetails?.remark}</Text>
              </div>

              <Text
                type="secondary"
                style={{
                  fontSize: 12,
                  display: "block",
                  marginTop: 8,
                }}
              >
                Raised by: {order.disputeDetails?.raisedBy?.firstName}{" "}
                {order.disputeDetails?.raisedBy?.lastName} | Date:{" "}
                {dateTimeToString(order.disputeDetails?.raisedDate)}
              </Text>
            </Card>
          ))}
        </>
      )}
    </Card>
  );
};

export default DisputeAnalysis;

const requestCorrectionsMap = {
  report: "Reports",
  acceptanceForm: "Acceptance Form",
  labellingForm: "Labelling Form",
};
